import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

Vue.use(VueLodash, { lodash });
window._ = lodash;

export default VueLodash;
